import CrossWindowMessenger from './cross-window-messenger';

const POPUP_URL = '/popup';
const POPUP_TARGET = 'TV3 Play';
const POPUP_FEATURES = 'width=480,height=640,resizable=yes,scrollbars=yes,status=yes';

export default class PopupWindow extends CrossWindowMessenger {
  constructor() {
    super();
    this.targetWindow = window.open(POPUP_URL, POPUP_TARGET, POPUP_FEATURES);
    this.checkPopupVisibility = this.checkPopupVisibility.bind(this);
    this.checkInterval = setInterval(this.checkPopupVisibility, 1000);
  }

  checkPopupVisibility() {
    if (!this.targetWindow) {
      return;
    }

    if (this.targetWindow.closed) {
      this.emit('close');
      this.destroy();
    } else if (!this.targetWindow.opener) {
      this.postMessage('CONNECT');
    }
  }

  load(url) {
    if (!this.targetWindow) {
      return;
    }

    this.targetWindow.location.href = url;
  }

  close() {
    if (!this.targetWindow) {
      return;
    }

    this.targetWindow.close();
    this.destroy();
  }

  destroy() {
    clearInterval(this.checkInterval);
    super.destroy();
  }
}
